/* eslint-disable no-continue */
import PropTypes from 'prop-types';
import { useState } from 'react';
import Star from '../../../widgets/Rating/star-full-half.svg';

export default function Rating(props) {
	const {
		rating,
		captureMouseEvents = false,
		callbackOnClick = null,
		clickedStar = null,
		onMouseHoverSetSingleStarInfo = null,
		onMouseLeaveSetSingleStarInfo = null,
		hasSubmitted,
	} = props;

	const [hoverRating, setHoverRating] = useState(null);

	const cssClassRatingEmpty = 'rating-empty';
	const cssClassRatingFull = 'rating-full';

	const rateArray = Array.from(Array(5).keys());

	const handleOnClick = (event) => {
		if (!captureMouseEvents && !hasSubmitted) return;
		callbackOnClick(event);
	};

	const handleOnMouseEnter = (event) => {
		if (!captureMouseEvents) return;

		setHoverRating(Number(event.target.dataset.rate));
		onMouseHoverSetSingleStarInfo(Number(event.target.dataset.rate));
	};

	const handleOnMouseLeave = () => {
		if (!captureMouseEvents) return;

		setHoverRating(null);
		onMouseLeaveSetSingleStarInfo();
	};

	const rateStars = rateArray.map((index) => {
		const isHovering = hoverRating && hoverRating >= index + 1;
		const isStickied = clickedStar && !hoverRating && clickedStar >= index + 1;
		return (
			<div
				onMouseEnter={handleOnMouseEnter}
				onMouseLeave={handleOnMouseLeave}
				onClick={handleOnClick}
				key={index}
				data-rate={index + 1}
				className={`star ${isHovering || isStickied ? cssClassRatingFull : cssClassRatingEmpty}`}
				role="presentation"
				aria-label={`${index + 1} out of 5 stars`}
			>
				<Star />
			</div>
		);
	});

	const scoreSummary = rateArray.map((index) => {
		let ratingClass = cssClassRatingEmpty;
		if (index < rating) {
			ratingClass = cssClassRatingFull;
		}
		return (<div key={index} role="img" aria-label={`${index + 1} out of 5 stars`} className={`star ${ratingClass}`}><Star /></div>);
	});

	const ariaLabel = (rating === 0) ? 'There is no rating for this recipe yet.' : `Rating: ${rating} out of 5 stars`;

	return (
		<>
			<div className="rating" data-rating={rating} role="img" aria-label={ariaLabel}>
				{captureMouseEvents ? rateStars : scoreSummary}
			</div>
		</>
	);
}

Rating.propTypes = {
	rating: PropTypes.number.isRequired,
	captureMouseEvents: PropTypes.bool,
	callbackOnClick: PropTypes.func,
	clickedStar: PropTypes.number,
	onMouseHoverSetSingleStarInfo: PropTypes.func,
	onMouseLeaveSetSingleStarInfo: PropTypes.func,
	hasSubmitted: PropTypes.bool.isRequired,
};
